// Centralized configuration for VCDPReport
const vcdpReportConfig = {
  reportKey: "vcdp_report_column_visibility",

  tableTemplate: [
    { field: "associate_id",           headerName: "Associate ID" },
    { field: "associate_name",         headerName: "Associate Name" },
    { field: "grade",                  headerName: "Grade" },
    { field: "skill",                  headerName: "Skill" },
    { field: "status",                 headerName: "Status" },
    { field: "release_initiated_date", headerName: "Release Initiated Date" },
    { field: "release_approved_date",  headerName: "Release Approved Date" },
    { field: "current_practice",       headerName: "Current Practice" },
    { field: "current_department",     headerName: "Current Department" },
    { field: "projectname",            headerName: "Project Name" },
    { field: "allocationstartdate",    headerName: "Allocation Start Date" },
    { field: "allocationenddate",      headerName: "Allocation End Date" },
    { field: "vertical",               headerName: "Vertical" },
    { field: "practice",               headerName: "Practice" },
    { field: "departmentname",         headerName: "Department" },
    { field: "releasingprojectid",     headerName: "Releasing Project ID" },
    { field: "releasingprojectname",   headerName: "Releasing Project Name" },
    { field: "releasingaccountname",   headerName: "Releasing Account Name" },
    { field: "releasingmarketunit",    headerName: "Releasing Market Unit" },
    { field: "releasingbusinessunit",  headerName: "Releasing Business Unit" },
    { field: "releasingprojectpmid",   headerName: "Releasing Project PM ID" },
    { field: "action",                 headerName: "Action" },
    { field: "previouscomments",       headerName: "Previous Comments" },
    { field: "visibility",             headerName: "Visibility" },
    { field: "benchageing",            headerName: "Bench Ageing" },
    { field: "ageingbucket",           headerName: "Ageing Bucket" },
    { field: "last_updated_date",      headerName: "Last Updated Date" },
    { field: "report_extraction_date", headerName: "Report Extraction Date" }
  ],

  filterTemplate: [
      { field: "skill",                  headerName: "Skill" },
    { field: "grade",                  headerName: "Grade" },
    { field: "region",                 headerName: "Region" },
   
    { field: "location",               headerName: "Location" },
    { field: "city",                   headerName: "City" },
   
  
    { field: "current_department",     headerName: "Current Department" },
     { field: "proposed_business_unit", headerName: "Proposed Business Unit" },
     { field: "action",                 headerName: "Action" }
  ]
};

export default vcdpReportConfig;
